import {
  agDepartmentsCol,
  agDetailCol,
  agEndDateCol,
  agPriceCol,
  agSelectCol,
  agStartDateCol,
  agStatusCol
} from '@/ag-grid/ag-columns'
import { notAnyPriceCheck } from '@/ag-grid/utils/notAnyValue'

export default {
  computed: {
    options() {
      return {
        columnDefs: [
          agSelectCol({ vuexModule: 'price-forecast' }),

          agStatusCol(),

          {
            headerName: 'SUBSCRIPTION',
            field: 'name',
            type: ['textFilterColumn'],
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/subscriptions/${params.data.subscription.id}`
              }
            }
          },

          {
            headerName: 'PUBLISHER',
            field: 'publisher.name',
            type: ['textFilterColumn']
          },

          {
            headerName: 'VENDOR',
            field: 'vendor.name',
            tooltipValueGetter: params => params.value || 'N/A',
            cellRenderer: params => params.value || 'N/A',
            type: ['textFilterColumn']
          },

          agDepartmentsCol('price-forecast', {
            headerName: this.departmentLabel.plural
          }),

          agStartDateCol(),

          agEndDateCol(),

          agDetailCol(),

          agPriceCol('LAST YEAR PRICE', 'previous_period.price'),

          agPriceCol('FORECASTED CHANGE', 'forecasted_change_percentage', {
            cellRenderer: params => {
              if (!params.value) return 'N/A'
              return `${Number(params.value)} %`
            },
            editable: params => params.data.previous_period?.price && params.data.previous_period.price !== '0.00',
            cellClassRules: {
              'editable-cell': params => {
                if (!params?.data) return
                return params.data.previous_period?.price && params.data.previous_period.price !== '0.00'
              }
            }
          }),

          agPriceCol('FORECASTED PRICE', 'forecasted_price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          agPriceCol('Forecasted local price', 'forecasted_local_price', {
            cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency'),
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          agPriceCol('ACTUAL CHANGE', 'actual_change_percentage', {
            hide: true,
            cellRenderer: params => {
              if (!params.value) return 'N/A'
              return `${Number(params.value)} %`
            }
          }),

          agPriceCol('Local price', 'normalized_price', {
            cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency')
          }),

          agPriceCol('PRICE', 'price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          })
        ],

        defaultColDef: {
          floatingFilter: true
        },

        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
